import { useLatestReviews } from "@/hooks/useReviews";
import { Star } from "lucide-react";
import TiltCard from "@/components/3d/TiltCard";
import ScrollReveal from "@/components/3d/ScrollReveal";

const ReviewsSection = () => {
  const { data: reviews = [] } = useLatestReviews(4);

  const fallbackReviews = [
    { id: "f1", rating: 5, comment: "The quality is insane. Best hoodie I've ever owned.", title: null, user_id: "", product_id: "", is_approved: true, created_at: "", reviewer_name: "Rahul S." },
    { id: "f2", rating: 5, comment: "Gonvex hits different. The fit is perfect every time.", title: null, user_id: "", product_id: "", is_approved: true, created_at: "", reviewer_name: "Priya M." },
  ];

  const displayReviews = reviews.length > 0 ? reviews : fallbackReviews;

  return (
    <section className="py-24">
      <div className="container mx-auto px-4">
        <ScrollReveal direction="up">
          <div className="text-center">
            <p className="text-xs font-semibold uppercase tracking-widest text-primary">Real People, Real Style</p>
            <h2 className="mt-2 font-display text-3xl font-bold sm:text-4xl">What They're Saying</h2>
          </div>
        </ScrollReveal>
        <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {displayReviews.map((r: any, i: number) => (
            <ScrollReveal key={r.id || i} direction={i % 2 === 0 ? "left" : "right"} delay={i * 0.05}>
              <TiltCard tiltAmount={12} glareOpacity={0.1}>
                <div className="rounded-2xl border border-border/50 bg-card p-6 hover-glow">
                  <div className="flex gap-0.5">
                    {Array.from({ length: r.rating }).map((_, j) => (
                      <Star key={j} className="h-4 w-4 fill-yellow-400 text-yellow-400" />
                    ))}
                  </div>
                  {r.title && <p className="mt-3 text-sm font-semibold">{r.title}</p>}
                  <p className="mt-3 text-sm text-muted-foreground">"{r.comment || 'Great product!'}"</p>
                  <div className="mt-4 flex items-center gap-3">
                    <div className="flex h-8 w-8 items-center justify-center rounded-full bg-primary/20 text-xs font-bold text-primary">
                      {(r.reviewer_name?.[0] || "G").toUpperCase()}
                    </div>
                    <span className="text-sm font-medium">{r.reviewer_name || "Gonvex Customer"}</span>
                  </div>
                </div>
              </TiltCard>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ReviewsSection;
